<template>
  <div class="home">
    <hero
      question="Magst du"
      question1="Blumen"
      question2="Bienen"
      question3="Frühlingefühle"
      claim="Prima! Dann verschenke doch mal eine ganze Blühwiese."
      solution="Blumen zum Valentinstag haben eine jahrhundertealte Tradition. Sie geht zurück auf den heiligen Valentin von Terni, einen Bischof und Märtyrer. Er war bekannt für seine wunderschönen Gärten und auch dafür, dass er gerne Blumen aus diesen Gärten an verliebte Paare schenkte. Auch wir haben eine riesige Wiese voller Wilder Pracht. Möchtest du davon Blumen verschenken?"
    />
    <textblock
      headline="Verschenke eine Blühpatenschaft zum Valentinstag!"
      column1="Blumen zum Valentinstag sind ein Symbol für die Liebe. Sie sollen Freude schenken. Mit der Wilden Pracht verschenkst du aber nicht bloß einen ganz normalen Blumenstrauß, sondern quadratmeterweise Wildblumen – so viele, wie du möchtest. Eine schöne Idee könnte sein, dass du für jedes Jahr, das ihr zusammen seid, einen Quadratmeter Wilde Pracht kaufst. Oder aber du hängst noch eine Null hinten dran. Denn bei einem kannst du dir gewiss sein: Die Bienen, Hummeln und Schmetterlinge freuen sich über jeden einzelnen Quadratmeter Blühwiese mindestens genauso wie der oder die Beschenkte."
      column2="Zusammen mit dir möchten wir das ganze Land im Sommer bunt erblühen lassen. Zu jeder Patenschaft bekommst du von uns ein Blühzertifikat per Post und eines, das du direkt im Anschluss an den Kauf herunterladen und ausdrucken kannst. Sollte dir die Idee für dieses tolle Geschenk also erst spät kommen: kein Problem! Und das ist noch nicht alles: Mit unserer digitalen Bienenpost können du und der oder die Beschenkte gemeinsam die ganze Blühsaison über verfolgen, was auf dem Feld passiert. So lange hält kein Blumenstrauß der Welt!"
    />
    <cta
      title="Werde jetzt Pate für die Blühsaison 2025."
      subtitle="Und verschenke Freude und Wilde Pracht!"
    />
    <Orderform />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Textblock from "@/components/Textblock.vue";
import Cta from "@/components/Cta.vue";
import Orderform from "@/components/Orderform/Orderform.vue";

export default {
  name: "Valentinstag",
  components: {
    Hero,
    Textblock,
    Cta,
    Orderform
  },
  metaInfo: {
    title: "Blumen zum Valentinstag schenken | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Mit der Wilden Pracht verschenkst du nicht bloß einen ganz normalen Blumenstrauß zum Valentinstag, sondern quadratmeterweise Wildblumen – so viele, wie du möchtest. "
      },
      { itemprop: "name", content: "Magst du Lebensfreude? | Wilde Pracht" },
      {
        property: "og:title",
        content: "Blumen zum Valentinstag schenken | Wilde Pracht"
      },
      {
        itemprop: "description",
        content:
          "Mit der Wilden Pracht verschenkst du nicht bloß einen ganz normalen Blumenstrauß zum Valentinstag, sondern quadratmeterweise Wildblumen – so viele, wie du möchtest. "
      },
      {
        property: "og:description",
        content:
          "Mit der Wilden Pracht verschenkst du nicht bloß einen ganz normalen Blumenstrauß zum Valentinstag, sondern quadratmeterweise Wildblumen – so viele, wie du möchtest. "
      }
    ]
  }
};
</script>

<style lang="scss"></style>
